module.exports = __webpack_public_path__ + "img/reg_school.00c7d736.svg";